import { render, staticRenderFns } from "./NavDrawerList.vue?vue&type=template&id=65297c52&"
import script from "./NavDrawerList.vue?vue&type=script&lang=js&"
export * from "./NavDrawerList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports